export default "__VITE_ASSET__DghMjnJV__"